module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTPro65Medium.92b3a022.otf";